import client from "./client";

export default {
    async getSmsLogs(filters){
        return client.parseResponse(client.parseResponse(await client.get('/sms-logs', filters)));
    },

    async resendSms(data) {
        return client.parseResponse(await client.get('/resend-sms/' + data.id));
    },

    // campaigns
    async getCampaigns(filters){
        return client.parseResponse(client.parseResponse(await client.get('/campaigns', filters)));
    },
    async createCampaign(data){
        return client.parseResponse(await client.upload('/campaigns', data))
    },
    async editCampaign(data){
        return client.parseResponse(await client.upload('/update-campaign' , data))
    },
    async getRecipients(data){
        return client.parseResponse(client.parseResponse(await client.get('/campaign-recipients', data)));
    },
    async getCampaign(id){
        return client.parseResponse(await client.get('/campaigns/' + id));
    },

    async exportSmsLogsReport(filters) {
        return client.parseResponse(await client.get('/export-sms-logs', filters, {responseType: 'blob'}));
    },
    async exportCampaignsReport(filters) {
        return client.parseResponse(await client.get('/export-campaigns', filters, {responseType: 'blob'}));
    },
}
